export default [
  {
    path: '/rechargeTime',
    meta: { title: '观看时长充值' },
    component: () =>
      import(
        /* webpackChunkName: "rechargeTime" */ '@/pages/rechargeTime/index.vue'
      )
  },
  {
    path: '/rechargeTime/success',
    meta: { title: '充值成功' },
    component: () =>
      import(
        /* webpackChunkName: "rechargeTime" */ '@/pages/rechargeTime/paySuccess.vue'
      )
  }
]
